import React from "react";
import "../styling/About.css";

import KILogo from "url:../assets/karolinska-institutet-logo.png";
import KIHLogo from "url:../assets/karolinska-hospita-logo.png";

const PROJECT_COORDINATORS = [
  "David Tamborero, PhD",
  "Maximillian Kordes, MD, PhD",
  "Janne Lehtiö, PhD",
];

const DESIGN_DEVELOPMENT = [
  "David Tamborero, PhD",
  "Ali Razzak, MSc",
  "Laura Gheorghe, BSc",
];

export default function About() {
  return (
    <main className="about-page">
      <section className="about-card">
        <div className="about-content">
          <p className="about-kicker">About PrOCaRe</p>

          <h1>Project information</h1>

          <p className="about-intro">
            PrOCaRe is developed and maintained at Karolinska Institutet.
          </p>

          <div className="about-section">
            <h2>Project coordinators</h2>
            <ul>
              {PROJECT_COORDINATORS.map((person) => (
                <li key={person}>{person}</li>
              ))}
            </ul>
          </div>

          <div className="about-section">
            <h2>Design &amp; Development</h2>
            <ul>
              {DESIGN_DEVELOPMENT.map((person) => (
                <li key={person}>{person}</li>
              ))}
            </ul>
          </div>

          <div className="about-section">
            <h2>Contact</h2>
            <p>
              For further information, please write to us at 
                <a href="mailto:procare@scilifelab.se">procare@scilifelab.se</a>.
            </p>
          </div>
        </div>

        <aside className="about-logos" aria-label="Affiliated organizations">
          <div className="about-logo-card">
            <a href="https://www.karolinska.se/" target="_blank">
                <img src={KIHLogo} alt="Karolinska Hospital logo"/>
              </a>
          </div>

          <div className="about-logo-card">
            <a href="https://ki.se/" target="_blank">
                <img src={KILogo} alt="Karolinska Institutet logo"/>
              </a>
          </div>
        </aside>
      </section>
    </main>
  );
}
